import React from 'react';

import { Button } from './elements';
import { useClickStreamContext } from '../ClickStream';
import { UserApi } from 'api';

const Logout = () => {
  const { logPageEvent } = useClickStreamContext();
  // const userData = useUserData();
  const exit = async () => {
    await UserApi.logout();
    localStorage.setItem('UPR_logged', 'false');

    logPageEvent({
      eventType: 'user_logout',
      eventInfo: 'Пользователь разлогинился',
    });
    window.location.reload();
  };

  // according new auth type via vk auth, delete return to admin panel, because it works wrong
  // const exitPretend = async () => {
  //   logPageEvent({
  //     eventType: 'user_pretend_exit',
  //     eventInfo: 'Вышел из притенда',
  //   });

  //   await PretendsApi.stopPretends();
  //   window.location.reload();
  // };

  return (
  // userData?.isPretended ? (
  //   <Button onClick={exitPretend}>
  //     <IconPrentendLogout>{LogoutFromPretend}</IconPrentendLogout>
  //     ВЕРНУТЬСЯ В КАБИНЕТ
  //   </Button>
  // ) : (
    <Button onClick={exit} data-qa-id="exitButton">
      ВЫХОД
    </Button>
  );
};

export default Logout;
